import AdminResource from "./AdminResource";

const SECTORES = ["Manufactura", "Farmacéutica veterinaria", "Industria alimentaria", "Servicios", "Tecnología", "Logística", "Comercio", "Sector público", "Agroindustria", "Salud", "Educación", "Otros"];
const NORMAS = ["ISO 9001", "ISO 14001", "ISO/IEC 27001", "FSC", "INTE G38", "Bandera Azul Ecológica"];

export const AdminCasos = () => (
  <AdminResource
    collection="casos"
    title="Casos de éxito"
    listColumns={["titulo", "sector", "norma", "anio"]}
    fields={[
      { name: "titulo", label: "Título del proyecto", type: "text" },
      { name: "empresa", label: "Nombre de la empresa (o placeholder anónimo)", type: "text" },
      { name: "sector", label: "Sector", type: "select", options: SECTORES },
      { name: "pais", label: "País", type: "text" },
      { name: "ciudad", label: "Ciudad", type: "text" },
      { name: "norma", label: "Norma o certificación", type: "select", options: NORMAS },
      { name: "servicio", label: "Servicio realizado", type: "text" },
      { name: "duracion", label: "Duración aproximada", type: "text" },
      { name: "anio", label: "Año", type: "number" },
      { name: "image", label: "Imagen principal (URL)", type: "text" },
      { name: "logo_cliente", label: "Logotipo del cliente (URL)", type: "text" },
      { name: "situacion", label: "Situación inicial", type: "textarea" },
      { name: "problema", label: "Problema o necesidad", type: "textarea" },
      { name: "objetivos", label: "Objetivos", type: "list" },
      { name: "diagnostico", label: "Diagnóstico realizado", type: "textarea" },
      { name: "acciones", label: "Acciones ejecutadas", type: "list" },
      { name: "metodologia", label: "Metodología utilizada", type: "textarea" },
      { name: "desafios", label: "Principales desafíos", type: "textarea" },
      { name: "soluciones", label: "Soluciones implementadas", type: "textarea" },
      { name: "resultados", label: "Resultados obtenidos", type: "textarea" },
      { name: "testimonio", label: "Testimonio del cliente", type: "textarea" },
      { name: "destacado", label: "Destacado en landing", type: "bool" },
    ]}
    defaults={{ destacado: false }}
  />
);

export const AdminServices = () => (
  <AdminResource
    collection="services"
    title="Servicios"
    listColumns={["titulo", "descripcion"]}
    fields={[
      { name: "titulo", label: "Título", type: "text" },
      { name: "descripcion", label: "Descripción", type: "textarea" },
    ]}
  />
);

export const AdminNormas = () => (
  <AdminResource
    collection="normas"
    title="Normas y certificaciones"
    listColumns={["codigo", "titulo"]}
    fields={[
      { name: "codigo", label: "Código (Ej. ISO 9001)", type: "text" },
      { name: "titulo", label: "Título completo", type: "text" },
      { name: "resumen", label: "Resumen", type: "textarea" },
      { name: "servicios_relacionados", label: "Servicios relacionados", type: "list" },
    ]}
  />
);

export const AdminClients = () => (
  <AdminResource
    collection="clients"
    title="Clientes"
    listColumns={["nombre", "logo_url"]}
    fields={[
      { name: "nombre", label: "Nombre", type: "text" },
      { name: "logo_url", label: "Logo URL", type: "text" },
      { name: "website", label: "Website", type: "text" },
    ]}
  />
);

export const AdminTestimonials = () => (
  <AdminResource
    collection="testimonials"
    title="Testimonios"
    listColumns={["nombre", "empresa"]}
    fields={[
      { name: "comentario", label: "Comentario", type: "textarea" },
      { name: "nombre", label: "Nombre", type: "text" },
      { name: "cargo", label: "Cargo", type: "text" },
      { name: "empresa", label: "Empresa", type: "text" },
      { name: "servicio", label: "Servicio recibido", type: "text" },
      { name: "foto_url", label: "Foto / logotipo URL", type: "text" },
      { name: "autorizado", label: "Autorizado para publicación", type: "bool" },
    ]}
    defaults={{ autorizado: true }}
  />
);

export const AdminFaqs = () => (
  <AdminResource
    collection="faqs"
    title="Preguntas frecuentes"
    listColumns={["pregunta"]}
    fields={[
      { name: "pregunta", label: "Pregunta", type: "text" },
      { name: "respuesta", label: "Respuesta", type: "textarea" },
    ]}
  />
);

export const AdminResources = () => (
  <AdminResource
    collection="resources"
    title="Recursos"
    listColumns={["titulo", "tipo"]}
    fields={[
      { name: "titulo", label: "Título", type: "text" },
      { name: "slug", label: "Slug SEO (ej. guia-iso-9001)", type: "text" },
      { name: "tipo", label: "Tipo (Guía, Artículo, Webinar...)", type: "text" },
      { name: "resumen", label: "Resumen", type: "textarea" },
      { name: "seo_description", label: "Descripción SEO", type: "textarea" },
      { name: "contenido", label: "Contenido (separar párrafos con una línea vacía)", type: "textarea" },
      { name: "autor", label: "Autor", type: "text" },
      { name: "fecha", label: "Fecha (AAAA-MM-DD)", type: "text" },
      { name: "url", label: "Enlace externo", type: "text" },
      { name: "imagen", label: "Imagen URL", type: "text" },
    ]}
  />
);

export const AdminSectors = () => (
  <AdminResource
    collection="sectors"
    title="Sectores"
    listColumns={["nombre"]}
    fields={[{ name: "nombre", label: "Nombre del sector", type: "text" }]}
  />
);

export const AdminRequests = () => (
  <AdminResource
    collection="contact_requests"
    title="Solicitudes recibidas"
    listColumns={["nombre", "empresa", "email", "servicio_interes"]}
    fields={[
      { name: "nombre", label: "Nombre", type: "text" },
      { name: "email", label: "Correo", type: "text" },
      { name: "telefono", label: "Teléfono", type: "text" },
      { name: "empresa", label: "Empresa", type: "text" },
      { name: "pais", label: "País", type: "text" },
      { name: "ciudad", label: "Ciudad", type: "text" },
      { name: "servicio_interes", label: "Servicio de interés", type: "text" },
      { name: "mensaje", label: "Mensaje", type: "textarea" },
      { name: "estado", label: "Estado", type: "select", options: ["nuevo", "en proceso", "atendido", "cerrado"] },
    ]}
  />
);
